export default {
    getCssProperty: function (selector, prop) {

        let $inspector = $("<div>").css('display', 'none').addClass(selector.split('.').join(' '));

        $("body").append($inspector); // add to DOM, in order to read the CSS property
        try {
            return $inspector.css(prop);
        } finally {
            $inspector.remove(); // and remove from DOM
        }

    }
}
